import { School } from "@/ts/objects/entity/school";

export const fakeSchool: School = {
  schoolName: "ABC小学校",
  logoGcsUrl: "dummy",
};
